import { Title, Divider, rem } from "@mantine/core";
import { useState } from "react";
import { TextInput, Textarea, Checkbox, Button, Group } from "@mantine/core";
import { useRef } from "react";
import { TestimonialCard } from "./Testimonials";
import { showNotification } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import axios from "axios";

const Feedback = () => {
    const [username, setUsername] = useState("");
    const [avatar, setAvatar] = useState<File | null>(null);
    const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
    const [feedback, setFeedback] = useState("");
    const [approved, setApproved] = useState(false);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleAvatarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setAvatar(file);
            setAvatarUrl(URL.createObjectURL(file));
        }
    };

    const toBase64 = (file: File) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    return (
        <div className="mx-8 text-left">
            <Title mb="sm">Feedback</Title>

            <Divider mb="xl" />

            <>
                <div className="space-y-8" align="start">
                    <TextInput
                        label="Username or first name"
                        placeholder="Your name"
                        value={username}
                        onChange={(e) => setUsername(e.currentTarget.value)}
                    />
                    <div>
                        <label style={{ fontWeight: 500, marginBottom: 4, display: "block" }}>Avatar</label>
                        <Group>
                            <Button variant="outline" onClick={() => fileInputRef.current?.click()} size="sm">
                                Upload avatar (max 50 KB)
                            </Button>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={handleAvatarChange}
                            />
                        </Group>
                    </div>
                    <Textarea
                        label="Feedback"
                        placeholder="Your feedback"
                        value={feedback}
                        onChange={(e) => setFeedback(e.currentTarget.value)}
                        minRows={4}
                    />
                </div>
                <Divider my="xl" label="Preview" labelPosition="center" />
                <TestimonialCard
                    item={{
                        content: feedback,
                        name: username,
                        avatar: avatarUrl || "",
                    }}
                />
                <Checkbox
                    mt="xl"
                    label="I approve that this feedback can be shown 
publicly on openingtrainer.com"
                    checked={approved}
                    onChange={(e) => setApproved(e.currentTarget.checked)}
                />
            </>

            <Button
                mt="xl"
                variant="filled"
                color="blue"
                disabled={!username || !feedback}
                onClick={async () => {
                    if (avatar && avatar.size > 50000) {
                        showNotification({
                            title: "Error",
                            message: "Avatar size must be less than 50 KB.",
                            color: "red",
                        });
                        return;
                    }

                    try {
                        const avatarBase64 = avatar ? await toBase64(avatar) : null;
                        await axios.post(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/feedback`, {
                            username,
                            avatar: avatarBase64 || "",
                            feedback,
                            approved,
                            site: "openingtrainer.com",
                        });

                        showNotification({
                            title: "Feedback submitted",
                            message: "Thank you for your feedback! It will be reviewed shortly.",
                            color: "green",
                            icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
                            autoClose: 5000,
                        });

                        setUsername("");
                        setAvatar(null);
                        setAvatarUrl(null);
                        setFeedback("");
                        setApproved(false);
                    } catch (error) {
                        console.error("Error submitting feedback:", error);
                        showNotification({
                            title: "Error",
                            message: "There was an error submitting your feedback. Please try again later.",
                            color: "red",
                        });
                    }
                }}
            >
                Submit
            </Button>
        </div>
    );
};

export default Feedback;
